import { Loader2, Inbox, AlertTriangle } from "lucide-react";

export function LoadingState({ label = "Loading...", testid = "loading-state" }) {
  return (
    <div data-testid={testid} className="flex flex-col items-center justify-center gap-3 py-16 text-[color:var(--text-muted)]">
      <Loader2 className="h-8 w-8 animate-spin text-[color:var(--accent-gold)]" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function EmptyState({ label = "No data found", hint, testid = "empty-state" }) {
  return (
    <div data-testid={testid} className="flex flex-col items-center justify-center gap-2 py-16 text-center">
      <Inbox className="h-10 w-10 text-[color:var(--accent-maroon)]" />
      <p className="text-[color:var(--text-secondary)] font-medium">{label}</p>
      {hint && <p className="text-xs text-[color:var(--text-muted)]">{hint}</p>}
    </div>
  );
}

export function ErrorState({ label = "Something went wrong", onRetry, testid = "error-state" }) {
  return (
    <div data-testid={testid} className="flex flex-col items-center justify-center gap-3 py-16 text-center">
      <AlertTriangle className="h-10 w-10 text-[color:var(--accent-crimson)]" />
      <p className="text-[color:var(--text-secondary)]">{label}</p>
      {onRetry && (
        <button data-testid="error-retry-btn" onClick={onRetry} className="btn-gold rounded-full px-5 py-2 text-sm">
          Try again
        </button>
      )}
    </div>
  );
}

export function SkeletonCard() {
  return (
    <div className="gold-border rounded-2xl p-4 bg-[color:var(--bg-card)] animate-pulse">
      <div className="h-4 w-1/2 rounded bg-white/10" />
      <div className="mt-4 h-8 w-2/3 rounded bg-white/10" />
      <div className="mt-3 h-3 w-1/3 rounded bg-white/10" />
    </div>
  );
}
